import styled from 'styled-components';

export const DataPointMappingHeaderLayout = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

export const DataPointMappingHeaderTitle = styled.div`
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
`;

export const DataPointMappingHeaderUnion = styled.div`
    min-width: 72px;
    height: 1px;
`;
